import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Box, X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { locRoom } from "@/data/rooms";

export const RoomPanel = ({ room: raw, onEnter3D, onClose, className = "" }) => {
  const { t, lang } = useLang();
  const room = locRoom(raw, lang);
  return (
  <motion.aside
    key={room.id}
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    className={`panel ${className}`}
    data-testid="room-panel"
  >
    {onClose && (
      <button onClick={onClose} className="icon-btn absolute right-3 top-3 z-10" aria-label={t("common.close")} data-testid="room-panel-close">
        <X size={16} />
      </button>
    )}
    <div className="arch-frame aspect-[4/5] max-h-[300px] w-full">
      <img src={room.img} alt={room.name} className="h-full w-full object-cover" />
    </div>
    <div className="mt-5 flex items-center gap-3">
      <span className="h-2 w-2 rounded-full" style={{ background: room.color }} />
      <span className="mono text-[11px] text-[var(--muted)]">{room.num} · {room.dims} · {room.area} m²</span>
    </div>
    <h3 className="mt-2 font-display text-4xl leading-none" data-testid="room-panel-name">{room.name}</h3>
    <p className="mt-1 font-display text-xl italic" style={{ color: room.color }}>{room.title}</p>
    <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{room.summary}</p>
    <div className="mt-5 flex flex-wrap gap-2">
      {onEnter3D && (
        <button onClick={() => onEnter3D(room.id)} className="btn-primary" data-testid="room-panel-enter-3d">
          <Box size={16} /> {t("room.enter3d")}
        </button>
      )}
      <Link to={`/salas/${room.id}`} className="btn-ghost" data-testid="room-panel-detail-link">
        {t("room.sheet")} <ArrowUpRight size={16} />
      </Link>
    </div>
  </motion.aside>
  );
};
